import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';
import Ctllogo from '../assets/ctl_logo1-removebg-preview.png';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToEnrollmentForm = () => {
    closeMenu();
    const enrollmentFormSection = document.getElementById('enroll');
    if (enrollmentFormSection) {
      enrollmentFormSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="navbar" aria-label="Main">
      <button
        type="button"
        className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={handleMenuToggle}
        aria-expanded={isMobileMenuOpen}
        aria-controls="primary-navigation"
        aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>
      <div className="logo">
        <img src={Ctllogo} alt="Cleveland Tennis Lessons logo" />
      </div>
      <ul
        id="primary-navigation"
        className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}
      >
        <li><a href="#home" onClick={closeMenu}>Home</a></li>
        <li><a href="#about" onClick={closeMenu}>About</a></li>
        <li><a href="#coaching" onClick={closeMenu}>Coaching</a></li>
        <li><a href="#contact" onClick={closeMenu}>Contact</a></li>
        <li>
          <button
            type="button"
            className="book-button"
            onClick={scrollToEnrollmentForm}
          >
            Book Now
          </button>
        </li>
      </ul>

    </nav>
  );
}

export default Navbar;
